import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const PAGE_TITLE_KEYS: Record<string, string> = {
	"/": "pageTitles.marketIntelligence",
	"/fleet-valuation": "pageTitles.fleetValuation",
	"/reports": "pageTitles.reports",
	"/vessel-market-values": "pageTitles.vesselMarketValues",
	"/ship-database": "pageTitles.shipDatabase",
	"/profitability-simulator": "pageTitles.profitabilitySimulator",
	"/auth/login": "pageTitles.login",
	"/auth/signup": "pageTitles.signUp",
	"/auth/callback": "pageTitles.login",
	"/auth/verify-email": "auth.emailVerification",
};

const APP_NAME = "MarinaValue";

export function usePageTitle() {
	const { t } = useTranslation();
	const { pathname } = useLocation();

	useEffect(() => {
		const key = PAGE_TITLE_KEYS[pathname];
		const pageTitle = key ? t(key) : null;
		document.title = pageTitle ? `${pageTitle} | ${APP_NAME}` : APP_NAME;
	}, [pathname, t]);
}
